import script from "./Provider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Provider.vue?vue&type=script&setup=true&lang=ts"

import "./Provider.vue?vue&type=style&index=0&id=7386976b&lang=scss"

const __exports__ = script;

export default __exports__